import { Box, Button, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { profileAccent, profileAccentDark } from "./profileFormStyles";

const SubmitButton = ({ loading }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        borderTop: "1px solid #e2e8f0",
        display: "flex",
        gap: 2,
        justifyContent: "flex-end",
        mt: 3.5,
        pt: 2.5,
      }}
    >
        <Button
          type="button"
          variant="outlined"
          onClick={() => navigate(-1)}
          disabled={loading}
          sx={{
            borderColor: "#cbd6e2",
            borderRadius: "999px",
            color: "#172033",
            fontWeight: 600,
            minHeight: 40,
            minWidth: 104,
            px: 2.5,
            textTransform: "none",
            "&:hover": {
              borderColor: "#94a3b8",
              backgroundColor: "#f8fafc",
            },
          }}
        >
          Cancelar
        </Button>
        <Button
          type="submit"
          variant="contained"
          disabled={loading}
          sx={{
            backgroundColor: profileAccent,
            borderRadius: "999px",
            boxShadow: "0 8px 18px rgba(95, 72, 246, 0.18)",
            fontWeight: 700,
            minHeight: 40,
            minWidth: 104,
            px: 3,
            textTransform: "none",
            "&:hover": {
              backgroundColor: profileAccentDark,
              boxShadow: "0 10px 22px rgba(95, 72, 246, 0.22)",
            },
          }}
        >
          {loading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Salvar"
          )}
        </Button>
    </Box>
  );
};

export default SubmitButton;
